import { fillDocumentFields } from '@/core/documents/fill-document.js';
import {
  WORK_RIGHTS_AU_FIELDS,
  WORK_RIGHTS_AU_RESIDENCY_VALUES,
} from '@/core/field-names';

export function fillWorkRights(document, changedField) {
  let dependentFieldNames;
  let newValue;
  switch (changedField.name) {
    case WORK_RIGHTS_AU_FIELDS.RESIDENCY:
      if (
        [
          WORK_RIGHTS_AU_RESIDENCY_VALUES.NZ_CITIZEN,
          WORK_RIGHTS_AU_RESIDENCY_VALUES.OTHER,
        ].includes(changedField.value)
      ) {
        dependentFieldNames = [WORK_RIGHTS_AU_FIELDS.DOC_TYPE];
        newValue = null;
        return fillDocumentFields(dependentFieldNames, document, newValue);
      }
      break;
  }
  return document.fields;
}
